// Switching a card's cover type rewrites page 0 on the server. While the switch is in flight, autosave must
// not write the pre-switch pages back, and afterwards undo must not step back to the pre-switch page 0
// (the card's cover type would no longer match its cover page).

let switching = false;
let undoFloor = 0;

export const coverSwitchGuard = {
	begin: () => {
		switching = true;
	},
	end: () => {
		switching = false;
	},
	isSwitching: () => switching,
	/** Undo may not go to a history step below this one. */
	setUndoFloor: (step: number) => {
		undoFloor = step;
	},
	canUndoFrom: (stepNum: number) => stepNum > undoFloor,
};
